<div class="edit-modal">
	<p-toast></p-toast>
	<p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>

	<cv-invision-outgoing-events-hybrid-tabs
		#tabsComponent
		*ngIf="hybridConfig?.hybridData"
		[config]="hybridConfig"
	></cv-invision-outgoing-events-hybrid-tabs>
</div>